<template>
  <PaymentAdvertisement
    :base-price="
      currentGrade?.price as productAPI.GetBestOffersResponse[number]['price']
    "
    icon-classes="w-[40px] flex-shrink-0 mr-8 self-center"
    :payment-methods="currentGrade?.paymentMethods"
    spot="product"
    @open="trackOpen"
  />
</template>

<script lang="ts" setup>
import { productAPI } from '@backmarket/http-api'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import PaymentAdvertisement from '~/scopes/payment/scopes/advertising/components/PaymentAdvertisement/PaymentAdvertisement.vue'
import { usePaymentAdvertisement } from '~/scopes/payment/scopes/advertising/composables/usePaymentAdvertisement'

withDefaults(
  defineProps<{
    currentGrade?: productAPI.GetBestOffersResponse[number] | null
  }>(),
  {
    currentGrade: null,
  },
)

const { trackClick } = useTracking()

function trackOpen(advertisement: ReturnType<typeof usePaymentAdvertisement>) {
  trackClick({
    zone: 'installment plans',
    name: advertisement.value?.isAdvertised
      ? advertisement.value?.method.networks.join(',')
      : '',
  })
}
</script>
